import Raven from 'raven-js';
import { app } from '../../../bootstrap/core';
import ravenHttpInterceptor from './ravenHttpInterceptor';

// Configure and install raven to the angular application for sentry error tracking.
Raven.config(
  'https://03ead89f43e946868523f6a941e64394@o46994.ingest.sentry.io/6311010',
  {
    release: ENV_CONFIG.build,
    ignoreErrors: [/\$rootScope:inprog.*/],
  },
).install();

// Log HTTP response errors to Sentry
app.config(ravenHttpInterceptor);

app.run(($window) => {
  'ngInject';
  $window.Raven = Raven;
});

app.factory('errorTrackingService', ($raven) => {
  'ngInject';
  return {
    captureMessage: $raven.captureMessage,
    captureException: $raven.captureException,
    setUserContext: $raven.setUserContext,
  };
});



// WEBPACK FOOTER //
// ./src/app/common/tracking/sentry/index.js